export const getBaseUrl = (): string => import.meta.env.BASE_URL;
